export const drinkViewStyle = () => {
  return {
    outer: 'w-full flex flex-col md:pt-12 md:flex-row md:items-start',
    return: '-mt-4 mb-4 text-sm sm:-mt-2 sm:mb-6 sm:text-base md:hidden',
    img: 'w-2/3 mx-auto sm:w-1/2 mb-8 shadow-lg md:basis-1/3 md:min-w-img md:mr-16',
    inner: 'md:basis-2/3',
    textSpacing: 'mt-10',
    ingredientList: 'list-disc ml-4',
    instructionList: 'list-decimal ml-4',
  };
};
